import { ContentPageTemplateComponent } from '../components/templates/content-page-template/content-page-template.component';
import { CheckoutAllInOnePageTemplateComponent } from '../components/templates/checkout-all-in-one-page-template/checkout-all-in-one-page-template.component';
import { TwoColumPageTemplateComponent } from '../components/templates/two-colum-page-template/two-colum-page-template.component';

export const templateMapping = {
  lmhFeatureSalesPageTemplate: ContentPageTemplateComponent,
  lmhFsContentPageTemplate: ContentPageTemplateComponent,
  lmhContentPageTemplate: ContentPageTemplateComponent,
  lmhProductDetailPageTemplate: ContentPageTemplateComponent,
  lmhCheckoutPageTemplate: CheckoutAllInOnePageTemplateComponent,
  lmhCheckoutAllInOnePageTemplate: CheckoutAllInOnePageTemplateComponent,
  lmhTwoColumnPageTemplate: TwoColumPageTemplateComponent,
  lmhProductListPageTemplate: ContentPageTemplateComponent,
  contentPageTemplate: ContentPageTemplateComponent,
  productDetailPageTemplate: ContentPageTemplateComponent,
  checkoutPageTemplate: CheckoutAllInOnePageTemplateComponent,
  checkoutAllInOnePageTemplate: CheckoutAllInOnePageTemplateComponent,
  twoColumnPageTemplate: TwoColumPageTemplateComponent,
  productListPageTemplate: ContentPageTemplateComponent
};
